'use es6';

import 'I18n/init/data/currency';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { Application } from 'foundations-components/components/Application';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import WindowDimensionsProvider from 'marketplace-ui-common/components/providers/WindowDimensionsProvider';
import HSAnalyticsProvider from 'marketplace-ui-common/tracking/components/HSAnalyticsProvider';
import { UsageTrackerProvider } from 'marketplace-ui-tracking';
import { renderWithNavCopilot } from 'quartz-core/client-with-copilot';
import { Provider } from 'react-redux';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { Router } from 'react-router-dom';
import { createTracker as createInAppTracker } from 'usage-tracker';
import { createTracker as createPublicTracker } from 'usage-tracker-public';
import { getAccreditations } from './actions/AccreditationsActions';
import { startApp } from './actions/AppActions';
import { getPartnerAwards } from './actions/AwardsActions';
import { getAcademyCertifications } from './actions/CertificationsActions';
import FeedbackSurveyLoader from './components/FeedbackSurveyLoader';
import Routes from './components/Routes';
import { fetchIntegrationsThunk } from './slices/integrationsSlice';
import { fetchActiveServicesThunk } from './slices/serviceCatalogSlice';
import configureStore from './utils/configureStore';
import { debug, setDebugGate, setDebugKey } from './utils/env';
import { createHistory } from './utils/history';
import { getAppRootUrl } from './utils/urls';
import { getTrackerConfig } from './utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dataFetchingClient = new DataFetchingClient();
export default class App {
  constructor() {
    this.setDebugKey = (key, value) => setDebugKey(key, value);
    this.setDebugGate = (gate, ...args) => setDebugGate(gate, ...args);
  }
  start() {
    if (debug()) {
      window.appInstance = this;
    }
    this.store = configureStore();
    this.initialize().then(() => this.startApp()).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }
  initialize() {
    return Promise.resolve();
  }
  registerI18n(I18nProvider) {
    return Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
  }
  getRootUrl() {
    return getAppRootUrl();
  }
  getRhumbConfig() {}
  getApplicationComponent() {
    return Application;
  }
  startApp() {
    this.store.dispatch(startApp());
    this.store.dispatch(getPartnerAwards());
    this.store.dispatch(getAcademyCertifications());
    this.store.dispatch(getAccreditations());
    this.store.dispatch(fetchActiveServicesThunk());
    this.store.dispatch(fetchIntegrationsThunk());
    this.startRouter();
  }
  startRouter() {
    const history = createHistory(this.getRootUrl());
    const ApplicationComponent = this.getApplicationComponent();
    const appContext = this.store.getState().app.appContext;
    let tracker;
    if (appContext === 'PUBLIC') {
      const config = getTrackerConfig('public');
      config.isExternalHost = false;
      tracker = createPublicTracker(config);
    } else {
      const config = getTrackerConfig('in-app');
      tracker = createInAppTracker(config);
    }
    renderWithNavCopilot( /*#__PURE__*/_jsx(CopilotProvider, {
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: dataFetchingClient,
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            config: this.getRhumbConfig(),
            history: historyAdapter(history),
            children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
              children: /*#__PURE__*/_jsx(UsageTrackerProvider, {
                tracker: tracker,
                children: /*#__PURE__*/_jsxs(WindowDimensionsProvider, {
                  children: [/*#__PURE__*/_jsx(Router, {
                    history: history,
                    children: /*#__PURE__*/_jsxs(ApplicationComponent, {
                      children: [/*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Routes, {})]
                    })
                  }), /*#__PURE__*/_jsx(FeedbackSurveyLoader, {})]
                })
              })
            })
          })
        })
      })
    }), {
      layoutType: 'panel-with-scroll'
    });
  }
}